import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider, addLocaleData } from 'react-intl'
import App from './App'
import translations from './i18n/'
import en from 'react-intl/locale-data/en'
import pt from 'react-intl/locale-data/pt'
import es from 'react-intl/locale-data/es'

addLocaleData([...en, ...pt, ...es])

const SUPPORTED_LOCALES = ['en', 'pt', 'es']
const language = (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage
const userLocale = language.toLowerCase().split(/[_-]+/)[0]
const locale = SUPPORTED_LOCALES.includes(userLocale) ? userLocale : 'en'
const messages = translations[locale].messages

ReactDOM.render(
  <IntlProvider locale={userLocale} messages={messages}>
    <App />
  </IntlProvider>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js